import React from "react"
import i18n from "i18next"
import { Layout, Head as HeadComponent } from "@bw/layouts"
import { PageHeader } from "@bw/modules"
import { Section } from "@bw/bits"
import { Authentication } from "@bw/partials"
import { useTranslation } from "react-i18next"
import { useUser } from "contexts/user"
import { reset } from "services/authentication"

export const Head = ({ location, pageContext }) => (
  <HeadComponent
    title={i18n.t("account:resetTitle")}
    location={location}
    pageContext={pageContext}
    doNotIndex
  />
)

const Login = ({ pageContext, location }) => {
  const [user] = useUser()
  const { t } = useTranslation()

  return (
    <Layout {...{ pageContext, location }}>
      <PageHeader title={t("account:resetTitle")} />
      <Section>
        <Authentication
          step="reset"
          onSubmitReset={reset}
          user={user}
        />
      </Section>
    </Layout>
  )
}

export default Login

